module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reviewerDisabledHint":"Enable the Review module on this account first."},"de":{"reviewerDisabledHint":"Aktivieren Sie zuerst das Review-Modul für dieses Konto."}}')
  delete Component.options._Ctor
}
